<template>
    <div class="issued-task-item" @click="locationTo('weixin/weui/cooperate.html#detail/'+item.instId)">
      <div class="panel round-corner">
        <div class="img-wrap">
          <van-image
              width="48"
              height="48"
              lazy-load round fit="cover"
              :src="complete(getAvatarByUUID(item.starterUUID))"/>
        </div>

        <div class="content-wrap">
          <h4 class="title max-two-line ht-text-primary">{{item.title}}</h4>
          <div class="tag-wrap" v-if="tagArr">
            <van-tag v-for="(item, index) in tagArr" :key="index" :color="item.color">{{item.text}}</van-tag>
          </div>
          <div class="desc-wrap">
            <p class="desc ht-text-assist van-ellipsis">
              <span class="value">{{item.starterName}} 发起于 {{item.startTime}}</span>
            </p>
          </div>

          <div class="btn-wrap" v-if="btnArr">
            <van-button class="ht-text-assist ht-text-none-select" plain type="info" size="mini" v-for="(jtem, index) in btnArr"
                        :key="index"
                        @click.stop="locationTo('weixin/weui/cooperate.html#detail/'+item.instId)">
              {{jtem.text}}
            </van-button>
          </div>
        </div>
      </div>
    </div>
</template>

<script>
    import {Image, Tag, Button, Icon} from 'vant'
    import {getAvatarByUUID} from '@/utils/commons'
    import {locationTo,complete} from '@/utils/url'
    import moment from 'moment'

    export default {
        name: 'IssuedTaskItem',
        components: {
          [Image.name]: Image,
          [Tag.name]: Tag,
          [Button.name]: Button,
          [Icon.name]: Icon,
        },
        props: ['item'],
        data() {
            return {}
        },
        computed: {
            parsedStatus() {
                let parsedStatus
                if (this.item.status == "end") {
                  parsedStatus = 3
                } else if (this.item.status == "send") {
                  parsedStatus = 2
                } else if (this.item.status == "finish") {
                  parsedStatus = 0
                } else if (this.item.status == "revoke" || this.item.status == "haverevoke") {
                  parsedStatus = 1
                } else if (this.item.status == "back") {
                  parsedStatus = 4
                } else if (this.item.status == "draft") {
                  parsedStatus = 5
                } else if (this.item.status == "delete") {
                  parsedStatus = 6
                }
                return parsedStatus
            },
            tagArr() {
                let result = {}

                if (this.parsedStatus == 0) {
                    result.text = '已暂停'
                    result.color = '#FFBE00'
                } else if (this.parsedStatus == 1) {
                    result.text = '已撤销'
                    result.color = '#AAAAAA'
                } else if (this.parsedStatus == 2) {
                    result.text = '进行中'
                    result.color = '#04BE02'
                } else if (this.parsedStatus == 3) {
                    result.text = '已结束'
                    result.color = '#EF4F4F'
                } else if (this.parsedStatus == 4) {
                  result.text = '已退回'
                  result.color = '#AAAAAA'
                } else if (this.parsedStatus == 5) {
                  result.text = '已撤回'
                  result.color = '#AAAAAA'
                } else if (this.parsedStatus == 6) {
                  result.text = '已删除'
                  result.color = '#AAAAAA'
                }

                return [result]
            },
            descArr() {
                return [
                    {key: '发起部门', value: this.item.starteDeptName},
                    {key:'开始时间',value: moment(this.item.startTime).format("YYYY-MM-DD HH:mm")},
                    {key: '截止时间', value: moment(this.item.endTime).format("YYYY-MM-DD HH:mm")},
                    {key: '上报进度', value: {'1': '未读', '2': '已读', '3': '已上报', '4': '已完成'}[this.item.status]},
                ]
            },
            btnArr() {
                let btnArr = [{text: '查看详情', event: 'btnClick'}]
                return btnArr
            },
        },
        mounted() {
        },
        methods: {
          complete, getAvatarByUUID,locationTo
        }
    }
</script>

<style scoped lang="scss">
@import "~@/assets/css/theme/theme.scss";
    .issued-task-item{
      border-radius: 6px;
    }
    .panel {
      position: relative;
      background-color: #ffffff;
      padding: 15px 10px;
      display: flex;
      margin-bottom: 10px;

      .img-wrap {
        margin-right: 10px;
        flex-shrink: 0;
      }

      .content-wrap {
        flex-grow: 1;
        width: 0;

        .title {
          height: 38px;
          line-height: 38px;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
          @extend .font14;
        }

        .tag-wrap {
          margin-bottom: 10px;
        }

        .desc-wrap {
          height: auto;
          overflow: hidden;
          @extend .font12;
          color: #999999;

          &.desc-wrap-folded {
            height: 100px;
          }
        }

        .arrow-wrap {
          text-align: center;
          padding: 3px 0;
          border-radius: 2px;

          &:active {
            background-color: lighten(#000, 96%);
          }
        }

        .btn-wrap {
          text-align: right;

          button {
            line-height: 1;
            border: none;
            padding: 5px 7px;
            @extend .font12;
          }

          .van-icon {
            height: 22px;
            line-height: 22px;
          }
        }
      }
    }
</style>
